import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from '~/client-flow/contexts/ResponsiveContext';
import { useLocaleKeys } from '~/i18n';
import { ClosingContentDesktop } from './ClosingContentDesktop';
import { ClosingContentMobile } from './ClosingContentMobile';
export const GetClosingStepTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const ClosingStep = (param)=>{
    let { testId, onComplete } = param;
    const testIds = useMemo(()=>GetClosingStepTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('vendorOnboarding.closingStep');
    const { isMobile } = useResponsive();
    if (isMobile) {
        return /*#__PURE__*/ _jsx(ClosingContentMobile, {
            testIds: testIds,
            t: t,
            onComplete: onComplete
        });
    }
    return /*#__PURE__*/ _jsx(ClosingContentDesktop, {
        testIds: testIds,
        t: t,
        onComplete: onComplete
    });
};
